// this toggles all graveyards' objects
// TODO: show only the selected graveyard's objects
$(function() {
    $('#photo-view').click(function() {
        if ($(this).is(':checked')) {
            $('[data-layer]').each(function() {
                window.widget.setLayerVisibility($(this).data('layer'), false);
            });
            window.allGraveyards.forEach(function(item) {
                window.widget.setLayerVisibility(item.id + '-orto', true);
            });
            $('.legend').removeClass('legend-visible');
            $('.objects-view').prop('checked', true);
        }
    });

    $('#draw-view').click(function() {
        if ($(this).is(':checked')) {
            $('[data-layer]').each(function() {
                window.widget.setLayerVisibility($(this).data('layer'), true);
            });
            window.allGraveyards.forEach(function(item) {
                window.widget.setLayerVisibility(item.id + '-orto', false);
            });
            $('.legend').addClass('legend-visible');
        }
    });

    $('.legend-view').on('click', function() {
        $(this)
            .parent()
            .toggleClass('legend-view-inactive');
        $(this).toggleClass('legend-not-view');

        var visible = true;
        const layer = $(this)
            .parent()
            .data('layer');

        if (
            $(this)
                .parent()
                .hasClass('legend-view-inactive')
        ) {
            visible = false;
        } else {
            visible = true;
        }

        window.widget.setLayerVisibility(layer, visible);
    });

    $('.grave-outline').on('change', function() {
        if ($(this).is(':checked') === false) {
            window.widget.setLayerVisibility('Grave', false);
        } else {
            window.widget.setLayerVisibility('Grave', true);
        }
    });

    $('.objects-view').on('change', function() {
        if ($(this).is(':checked') === false) {
            $('[data-layer]').each(function() {
                window.widget.setLayerVisibility($(this).data('layer'), false);
            });
        } else {
            $('[data-layer]').each(function() {
                window.widget.setLayerVisibility($(this).data('layer'), true);
            });
        }
    });

    $('.street-map').on('change', function() {
        if ($(this).is(':checked') === false) {
            window.widget.setLayerVisibility('streetMap', false);
        } else {
            window.widget.setLayerVisibility('streetMap', true);
        }
    });
});
